import React, { useState } from 'react'
import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
import { FaWandMagicSparkles } from 'react-icons/fa6'
import { MdAdd, MdDelete } from 'react-icons/md'
import ReactPaginate from 'react-paginate'
import { Button, Modal, Form } from 'react-bootstrap';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { addAllDiagnosis, deleteAllDiagnosis, getAllDiagnosis, searchAllDiagnosis, showAllDiagnosis, updateAllDiagnosis } from '../../../redux/actions/Feedback.action';
import { FaEdit } from 'react-icons/fa';
import { PiWarningCircleBold } from 'react-icons/pi';
import { BsFileMedical } from 'react-icons/bs';
import { dateAppointment, getDateAppointment, updateDateAppointment } from '../../../redux/actions/Doctor.action';
import { useParams } from 'react-router-dom';

const NextAppointment = ({ patientIds }) => {

    const { id } = useParams()
    const dispatch = useDispatch()
    const diagnosisDatas = useSelector((state) => state.feedback)
    const dateAppointments = useSelector((state) => state.doctor)

    const [isLoading, setIsLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [ids, setIds] = useState()
    const [selectedDate, setSelectedDate] = useState('');

    const toggle = () => { setShow(!show) }
    const deleteToggle = () => { setDeleteModal(!deleteModal) }
    const updateToggle = () => { setUpdateModal(!updateModal) }

    const [mainPage, setMainPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(3);
    const limits = {
        page: mainPage,
        limit: rowsPerPage,
    }
    const initialValues = {
        newDateOfAppointment: ''
    }
    const type = localStorage.getItem('type')
    const [formData, setFormData] = useState({ newDateOfAppointment: '' })

    const validationSchema = Yup.object().shape({
        newDateOfAppointment: Yup.string().required('Date is required')
    });

    const [diagnosisData, setDiagnosisData] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchDefault, setSearchDefault] = useState({
        search: '',
    });

    const handleDateChange = (e) => {
        const selectedDateValue = e.target.value;
        setSelectedDate(selectedDateValue);
    };

    const searchData = (e) => {
        const newSearchQuery = e.target.value;
        setSearchQuery(newSearchQuery);
        const newSearchParams = {
            ...searchDefault,
            search: newSearchQuery || ''
        };
        setSearchDefault(newSearchParams);
        dispatch(searchAllDiagnosis(newSearchParams))
    };

    const ChangeMainPage = (selected) => {
        setMainPage(parseInt(selected.selected) + 1);
    };

    const handleRowsPerPageChange = (e) => {
        const newRowsPerPage = parseInt(e.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setMainPage(1);
    };

    const postPerPage = rowsPerPage;
    const PageCount = Math.ceil(
        dateAppointments?.getDateAppointment?.data?.totalCount / postPerPage,
    );

    const handleAdd = (values, { resetForm }) => {
        const payload = {
            appointmentId: id,
            newDateOfAppointment: values.newDateOfAppointment,
        }
        const payload1 = {
            patientId: patientIds
        }
        setIsLoading(true);
        dispatch(dateAppointment(payload, payload1, limits)).then(() => {
            toggle();
            resetForm();
            setIsLoading(false);
        }).catch(() => {
            setIsLoading(false);
        });
    };

    const handleUpdate = (values) => {
        const payload = {
            appointmentId: ids,
            newDateOfAppointment: values.newDateOfAppointment,
        }
        const payload1 = {
            patientId: patientIds
        }
        setIsLoading(true);
        dispatch(updateDateAppointment(payload, payload1, limits)).then(() => {
            updateToggle()
            setIsLoading(false);
        }).catch(() => {
            setIsLoading(false);
        });
    }

    const handleDelete = () => {
        dispatch(deleteAllDiagnosis(ids, patientIds, limits)).then(() => {
            deleteToggle()
            setMainPage(1)
        })
    }

    useEffect(() => {
        if (patientIds) {
            const payload = {
                patientId: patientIds
            }
            dispatch(getDateAppointment(payload, limits))
        }
    }, [mainPage, rowsPerPage, patientIds])


    const formatDate = (isoString) => {
        const date = new Date(isoString);
        const offset = date.getTimezoneOffset() * 60000; // Get timezone offset in milliseconds
        const localDate = new Date(date.getTime() - offset); // Adjust to local timezone
        return localDate.toISOString().slice(0, 16); // Get 'YYYY-MM-DDTHH:MM'
    };

    return (
        <>
            <div className='col-lg-6'>
                <div className="!bg-[#fff] shadow p-4 rounded-4 h-full">
                    <div className="d-flex justify-between">
                        <div className="flex gap-3 items-center">
                            <BsFileMedical className="fs-6" />
                            <h6 className="mb-0">Next Appointment</h6>
                        </div>

                        <div onClick={toggle} className="w-[30px] flex justify-center items-center h-[30px] rounded-circle !border-red-700 border-1 cursor-pointer">
                            <button><MdAdd className="fs-4 text-danger fw-bold" /></button>
                        </div>
                    </div>
                    <div className="mt-3">
                        <TableContainer>
                            <Table variant="simple" className="table-bordered">
                                <Thead className="!bg-theme-dark">
                                    <Tr>
                                        <Th className="!text-white">Date</Th>
                                        <Th className="!text-white">Time</Th>
                                        <Th className="!text-white">User</Th>
                                        <Th className="!text-white">Action</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {
                                        dateAppointments?.getDateAppointment?.data?.appointments?.length > 0 ? (
                                            dateAppointments?.getDateAppointment?.data?.appointments?.map((res) => {
                                                return (
                                                    <Tr key={res._id}>
                                                        <Td>{new Date(res.dateOfAppointment).toLocaleDateString()}</Td>
                                                        <Td> {new Date(res.dateOfAppointment).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true, })}</Td>
                                                        <Td>{dateAppointments?.getDateAppointment?.data?.authData?.name}</Td>
                                                        <Td>
                                                            <div className='flex items-center gap-3'>
                                                                <button>
                                                                    <FaEdit className='text-success' onClick={() => {
                                                                        updateToggle(); setIds(res._id);
                                                                        setFormData(res);
                                                                    }} title='update' />
                                                                </button>
                                                            </div>
                                                        </Td>
                                                    </Tr>
                                                )
                                            })
                                        ) : (
                                            <Tr>
                                                <Td colSpan={4} textAlign={'center'}>No any appointment</Td>
                                            </Tr>
                                        )
                                    }
                                </Tbody>
                            </Table>
                        </TableContainer>
                    </div>
                    <div className="flex justify-between items-center mt-2 text-sm">
                        <div>
                            Rows per page:
                            <select
                                value={rowsPerPage}
                                onChange={handleRowsPerPageChange}
                                className="ms-2 border rounded-md focus:outline-none"
                            >
                                <option value="">Select</option>
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={30}>30</option>
                                <option value={50}>50</option>
                            </select>
                        </div>

                        <ReactPaginate
                            breakLabel="..."
                            nextLabel=" >"
                            onPageChange={ChangeMainPage}
                            pageRangeDisplayed={5}
                            pageCount={PageCount}
                            previousLabel="< "
                            renderOnZeroPageCount={null}
                            className="pagination"
                        />
                    </div>
                </div>
            </div>

            {/* Add Toggle */}
            <Modal show={show} onHide={toggle}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Appointment</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleAdd}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-12">
                                        <Form.Group controlId="campaignDetail">
                                            <Form.Label>Next Appointment Date</Form.Label>
                                            <Form.Control
                                                type="datetime-local"
                                                name="newDateOfAppointment"
                                                value={values.newDateOfAppointment}
                                                onChange={(e) =>
                                                    setFieldValue('newDateOfAppointment', e.target.value)}
                                                className='shadow-none focus:!border-theme-dark'
                                            />
                                            <ErrorMessage name="newDateOfAppointment" component="div" className="text-danger" />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={toggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button
                                    type="submit"
                                    className="!bg-theme-dark border-0 px-4"
                                    disabled={isLoading}
                                >
                                    {isLoading ? 'Loading...' : 'Add'}
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* Update Toggle */}
            <Modal show={updateModal} onHide={updateToggle}>
                <Modal.Header closeButton>
                    <Modal.Title>Update Appointment</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={formData}
                    validationSchema={validationSchema}
                    onSubmit={handleUpdate}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-12">
                                        <Form.Group controlId="campaignDetail">
                                            <Form.Label>Next Appointment Date</Form.Label>
                                            <Form.Control
                                                type="datetime-local"
                                                name="newDateOfAppointment"
                                                value={values?.newDateOfAppointment}
                                                onChange={(e) =>
                                                    setFieldValue('newDateOfAppointment', e.target.value)}
                                                className='shadow-none focus:!border-theme-dark'
                                            />
                                            <ErrorMessage name="newDateOfAppointment" component="div" className="text-danger" />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={toggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button
                                    type="submit"
                                    className="!bg-theme-dark border-0 px-4"
                                    disabled={isLoading}
                                >
                                    {isLoading ? 'Loading...' : 'Update'}
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>
        </>
    )
}

export default NextAppointment;
